// @flow

import type {
  ArticleXRayData,
  ConditionGroupXRayData,
  ConditionXRayData,
} from 'docs/data';
import type {
  ArticleXRayRequestModel,
  ConditionGroupXRayRequestModel,
  ConditionXRayRequestModel,
} from 'docs/types';

const transformCondition = (
  model: ConditionXRayRequestModel,
): ConditionXRayData => {
  return {
    name: model.name,
    type: model.type,
    valid: model.valid,
  };
};

const transformConditionGroup = (
  model: ConditionGroupXRayRequestModel,
): ConditionGroupXRayData => ({
  affirmative: model.affirmative.map(transformCondition),
  negative: model.negative.map(transformCondition),
  inline: model.inline.map(transformCondition),
});

export const transformArticleXRay = (
  model: ArticleXRayRequestModel,
): ArticleXRayData => ({
  filename: model.filename || '',
  owner: model.owner || '',
  type: model.type,
  isDevbox: model.is_devbox,
  internal: model.internal,
  allowed: model.allowed,
  conditions: model.conditions
    ? transformConditionGroup(model.conditions)
    : null,
  translationPercent: model.translationPercent,
});
